module.exports = __webpack_public_path__ + "static/teddy3-9e71f9b3f2f53e262e92022846e4d101.png";